/**
 * How long a self-dismissing toast stays on screen, in milliseconds.
 *
 * This was three different numbers written at three call sites: `Toast.vue`
 * closed itself after 5000ms, while `UserSessionExpiredToast.vue` and
 * `UserPasswordChangedToast.vue` each waited 7000ms before acknowledging. Two
 * toasts stacked in the same container would therefore disappear at different
 * times for no reason a reader could recover from the code.
 *
 * 5000ms is kept as the shared value because it is the one the generic `Toast`
 * uses, so it is what the overwhelming majority of toasts already do.
 */
export const TOAST_AUTO_DISMISS_MS = 5000

/**
 * `RestoreToast` pulses its button to draw the eye before settling. It is a
 * separate value because it is an attention cue inside the dismiss window, not
 * a dismiss timer.
 */
export const TOAST_PULSE_MS = 2000
